// extracted by mini-css-extract-plugin
export var footer = "_mm-0";
export var inherit = "_mm-1";
export var input = "_mm-2";
export var modalContent = "_mm-3";
export var quillEditor = "_mm-4";
export var subtitle = "_mm-5";